import { useEffect } from "react";
import KnxLanguageMapping from "../KnxProductDataTools/LanguageMapping";
import type Device from "../models/Device";
import { ValueLevels } from "../models/KnxInstanceData";
import Logger from "../Logger";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { isUiModeDeveloper, isUiModeProductAdmin } from "../uiMode";
import KnxProperty2 from "./KnxParameterViewer/KnxProperty2";

const logger = new Logger();

export default function KnxProperty(params: {
  className?: string;
  device: Device;
  label: string;
  data: any;
  instanceId: string;
  moduleId: string;
  parameterId: string;
  onChange?: () => void;
  print?: PagePrintInfo | undefined;
  sceneList?: boolean;
}) {
  var { className, device, label, data, instanceId, moduleId, parameterId, onChange, print, sceneList } = params;

  useOnChangeWatcher(device.knxParameterViewer);

  console.log("KnxProperty redraw ", device.tag, parameterId);

  async function init() {
    if (device.template) {
      console.log("init ", device.tag, parameterId);

      //
      // update device only if needed
      //
      device.updateAllFromKnxMetadata(true);
    }
  }

  useEffect(() => {
    init();
  }, []);

  function WarningElement(props: { text: string }): any {
    const { text } = props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          maxWidth: "5cm",
        }}
      >
        <img
          src={"images/warning.png"}
          style={{
            width: "25px",
            height: "25px",
            marginLeft: "10px",
            position: "relative",
          }}
        />
        {text}
      </div>
    );
  }

  const res: any = [];

  if (data == undefined) {
    const text = state.translate(
      "sceneConnectionProperties.sceneSettingsNotAvailableJet",
      " Szeneneinstellungen noch nicht möglich.",
    );
    return <WarningElement text={text} />;
  }

  if (!device.template) {
    const text = state
      .translate("sceneConnectionProperties.selectProductForT1", "Wähle ein Produkt für diesen T1 aus!")
      .replace("T1", state.translate(`components.${device.className}`, device.className));
    return <WarningElement text={text} />;
  }

  const languageMapping = new KnxLanguageMapping();
  const language = state.settings.language;
  languageMapping.load(device.template?.knxProductData.nonPersistentXmlData, language);

  var itemRef = data;

  var currentValue = device.knxInstanceData.getValue(parameterId, instanceId);
  var inputElement: any = null;

  const knxProductDataIsLoaded = device.template?.knxProductData?.globalMapLoaded;

  if (!knxProductDataIsLoaded && !print) {
    inputElement = (
      <input
        style={{
          border: "none",
          borderBottom: "1px solid var(--defaultBorderColor)",
          background: "var(--colorTransparent)",
          marginBottom: "5px",
          width: "100px",
          flexGrow: "1",
        }}
        key={currentValue + "temp"} // no itx
        disabled={true}
        defaultValue={currentValue}
      />
    );
  } else {
    inputElement = (
      <KnxProperty2
        className={className}
        onChange={onChange}
        device={device}
        item={itemRef}
        refId={parameterId}
        instanceId={instanceId}
        chapterId={undefined}
      />
    );
  }

  const debugElement = null;

  return (
    <tr className={className}>
      <td style={{ verticalAlign: "middle" }}>
        <div className="scenePropLabel" style={{ paddingRight: "10px" }}>
          {label}
        </div>
      </td>
      <td>
        <div className="estadaColumn left">
          {inputElement}
          {isUiModeProductAdmin() && debugElement}
        </div>
      </td>
    </tr>
  );
}
